import request from '@/http/request'
import {
  getEditSimulate,
  submitSimulate,
} from '@/http/api'

export const getMockSet = (data) => {
  return request({
    url: getEditSimulate,
    data
  })
}

export const setMockExam = (data) => {
  return request({
    url: submitSimulate,
    data
  })
}